import * as cx from 'classnames';
import range from 'lodash-es/range';
import { STROLLER_STROLLEROPEDIA } from 'mk/autogenerated/translations/Strollers.daaaaefff0d7d05eb32f2bf3e5887364'
import { ScoreNumber, ScoreNumberType } from 'mk2/apps/strollers/components/ScoreNumber';
import { StrollerEntity } from 'mk2/apps/strollers/schemas';
import * as urls from 'mk2/apps/strollers/urls';
import Img from 'mk2/components/Img';
import LinkListItem, { LinkListItemPlaceholder } from 'mk2/components/LinkListItem';
import Panel from 'mk2/components/Panel';
import PanelHeading from 'mk2/components/PanelHeading';
import { url } from 'mk2/helpers/urls';
import * as React from 'react';
import styles from './Strollers.mscss';

interface OwnProps {
    className?: string;
    strollers: StrollerEntity[];
}

type Props = OwnProps;

const StrollersReviews: React.StatelessComponent<Props> = ({ className, strollers }) => (
    <Panel className={cx(styles.StrollersReviews, className)}>
        <PanelHeading
            title={STROLLER_STROLLEROPEDIA}
            url={urls.strollers}
        />
        <ul className={styles.StrollersReviews__list}>
            {strollers.map((stroller, index) => (
                <LinkListItem
                    key={stroller.id}
                    className={styles.StrollersReviews__listItem}
                    to={url(urls.strollersDetail, { slug: stroller.slug })}
                    title={stroller.name}
                    icon={
                        <Img
                            className={styles.UserStrollerItem__image__img}
                            src={stroller.firstPhoto.url100x100}
                            width={36}
                            height={36}
                        />
                    }
                >
                   <span className={styles.StrollersItem__rating}>
                        {stroller.userScore && (
                            <ScoreNumber score={parseFloat(stroller.userScore.toFixed(1))} type={ScoreNumberType.Small} />
                        )}
                   </span>
                </LinkListItem>
            ))}
        </ul>
    </Panel>
);

StrollersReviews.displayName = 'StrollersReviews';

export default StrollersReviews;

interface PlaceholderOwnProps {
    className?: string;
    length?: number;
}

export const StrollersReviewsPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ className, length = 4 }) => (
    <Panel className={cx(styles.StrollersReviewsPlaceholder, className)}>
        <PanelHeading title={STROLLER_STROLLEROPEDIA} />
        <ul className={styles.StrollersReviewsPlaceholder__list}>
            {range(length).map((idx) => (
                <LinkListItemPlaceholder key={idx} width={`${ [90, 85, 80, 70, 75, 85][idx % 6] }%`} />
            ))}
        </ul>
    </Panel>
);
